import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Stats } from '../components/sections/Stats';
import { Testimonials } from '../components/sections/Testimonials';
import { Includes } from '../components/sections/Includes';
import { Pricing } from '../components/sections/Pricing';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-brand-dark" data-id="element-162">
      <MetaPixel data-id="element-163" />
      <main data-id="element-164">
        <Hero data-id="element-165" />
        <Stats data-id="element-166" />
        <Includes data-id="element-167" />
        <Testimonials data-id="element-168" />
        <Pricing data-id="element-169" />
        <FAQ data-id="element-170" />
        <FinalCTA data-id="element-171" />
      </main>
      <Footer data-id="element-172" />
      <SocialProofPopup data-id="element-173" />
    </div>;
}